import { ClamIcon, CloseIcon } from "@/components/icons";
import { Button } from "antd";

export default function AlertCard({
  item,
  handleClose,
  title,
  desc,
  confirmText,
  cancelText,
  handleConfim,
  handleCancle,
}: {
  item: any;
  handleClose: Function;
  title: string;
  desc: string;
  confirmText: string;
  cancelText: string;
  handleConfim: Function;
  handleCancle: Function;
}) {
  return (
    <div
      className={`flex p-4 rounded-[16px] bg-white border border-[#E2E4E8] gap-2 relative w-full md:w-[380px] ${
        item?.hidden ? "hidden" : ""
      }`}
    >
      <ClamIcon className="text-[#FB6011]" />
      <div className="w-full">
        <div className="flex flex-col justify-start items-start gap-2">
          <div className="w-full justify-center text-text-color-primary text-sm font-semibold leading-tight">
            {title}
          </div>
          <div className="w-full justify-center text-text-color-secondary text-xs font-normal leading-[16px]">
            {desc}
          </div>
        </div>
        <div className="mt-4 flex gap-4">
          <Button className="black-button" onClick={() => handleConfim()}>
            {confirmText}
          </Button>
          <Button onClick={() => handleCancle()}>{cancelText}</Button>
        </div>
      </div>
      <div
        className="cursor-pointer absolute right-2 top-2"
        onClick={() => handleClose()}
      >
        <CloseIcon />
      </div>
    </div>
  );
}
